// extracted by mini-css-extract-plugin
export default {"CommentsButton":"il_a bih_wx bih_jb bih_xl bih_i bih_j bih_q bih_vt bih_et bih_so bih_sp bih_eg","CommentsButton__icon":"il_b bih_rz"};